import { ISettingsState, initialSettingsState } from './settings-state';
import { IEntitiesState } from '../shared/entities/entities-state';
import { createNamedWrapperReducer, isActionRelated } from '@core/utils/state';
import {
    EMPLOYEES_SUGGESTIONS_FETCH,
    SETTINGS_FETCH,
    SETTINGS_FETCHING_SET,
    SETTINGS_LEAVEPOLICIES_FETCH,
    SETTINGS_LEAVEPOLICIES_SET,
    SETTINGS_LEAVEPOLICY_NEW_RESET,
    SETTINGS_LEAVEPOLICY_NEW_UPDATE,
    SETTINGS_LEAVEPOLICY_VIEWED_SET,
    SETTINGS_TIMEOFF_TYPES_SET,
    SETTINGS_SET
} from '../action-types';
import { reducer as listReducer } from '../shared/list/reducer';
import {
    GROUP_EMPLOYEE_SUGGESTIONS,
    GROUP_SETTINGS_LEAVE_POLICIES
} from '../state-groups';

export function reducer(
    state: ISettingsState = initialSettingsState(),
    action: any,
    entitySlice: IEntitiesState): ISettingsState {        
      
    switch (action.type) {

        case SETTINGS_SET:
            return {
                ...state,
                settings: {
                    ...action.payload.settings
                }
            };

        case SETTINGS_FETCH:
            return {
                ...state,
                isFetching: true
            };

        case SETTINGS_FETCHING_SET:
            return {
                ...state,
                isFetching: action.payload
            };

        case EMPLOYEES_SUGGESTIONS_FETCH:
            return {
                ...state,
                suggestions: {
                    ...state.suggestions, isFetching: true
                }
            };

        case SETTINGS_LEAVEPOLICIES_FETCH:
            return {
                ...state,
                leavePolicies: {
                    ...state.leavePolicies, isFetching: true
                }
            };

        case SETTINGS_LEAVEPOLICIES_SET:
            return {
                ...state,
                leavePolicies: {
                    ...state.leavePolicies, isFetching: false
                }
            };

        case SETTINGS_LEAVEPOLICY_VIEWED_SET:
            return {
                ...state,
                viewedLeavePolicyId: action.payload.id
            }

        case SETTINGS_LEAVEPOLICY_NEW_UPDATE:
            return {
                ...state,
                newLeavePolicy: action.payload
            }

        case SETTINGS_LEAVEPOLICY_NEW_RESET:
            return {
                ...state,
                newLeavePolicy: null
            }

        case SETTINGS_TIMEOFF_TYPES_SET:
            return {
                ...state,
                timeoffTypes: action.payload.types
            }

        default:
            let nextState: ISettingsState = state;

            if (isActionRelated(action, [
                GROUP_EMPLOYEE_SUGGESTIONS,
                GROUP_SETTINGS_LEAVE_POLICIES
            ])) {
                nextState = {
                    ...state,
                    suggestions: createNamedWrapperReducer(
                        listReducer,
                        GROUP_EMPLOYEE_SUGGESTIONS
                    )(state.suggestions, action, entitySlice.entities),
                    leavePolicies: createNamedWrapperReducer(
                        listReducer,
                        GROUP_SETTINGS_LEAVE_POLICIES
                    )(state.leavePolicies, action, entitySlice.entities)
                };
            }

            return nextState;
    }
}
